import {useAppSelector} from '@/hooks';

export const useGetCurrentPageZoom = (): number | undefined => {
  const currentPageId = useAppSelector((state) => {
    return state.posterEditor.currentPageId;
  });
  return useAppSelector((state) => {
    return state.posterEditor.posterObject?.pages.pagesHashMap[currentPageId]?.zoom;
  });
};
